module.exports = __webpack_public_path__ + "static/WEDDING E&M-361-662643bd25fb6836e19922fd1ea30445.jpg";